module.exports = __webpack_public_path__ + "img/function-icon3.22bb0af2.png";